export default "__VITE_ASSET__C1NPzj5O__"